module.exports = __webpack_public_path__ + "media/images/icon__email@2x-1f90b5484439fafb8cfd7056d47525c5.png";